import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const updateDefectTodo = createAsyncThunk('updateDefect', async (data) => {
    try {
        const res = await axios({
            method: "put",
            url: process.env.REACT_APP_API_URL + `defect/${data?.id}`,
            data: {
                "name": data.defect,
                'category_status': data?.category,
                'remark': data?.remark,
                "status": data.status,
                "modified_by": localStorage.getItem('userId')

            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') }
        })
        return res
    } catch (error) {
        return error?.response
    }
})




